import i18n from '@/i18n';

export default [
  {
    text: i18n.t('enums.AcaoOrcamentoEnum.aprovadoServicos'),
    value: 'AprovadoServicos',
    cor: 'success',
  },
  {
    text: i18n.t('enums.AcaoOrcamentoEnum.aprovadoPecas'),
    value: 'AprovadoPecas',
    cor: 'success',
  },
  {
    text: i18n.t('enums.AcaoOrcamentoEnum.aprovadoServicosPecas'),
    value: 'AprovadoServicosPecas',
    cor: 'success',
  },
  {
    text: i18n.t('enums.AcaoOrcamentoEnum.aprovadoAutomaticamente'),
    value: 'AprovadoAutomaticamente',
    cor: 'success',
  },
  {
    text: i18n.t('enums.AcaoOrcamentoEnum.aprovadoParcialServicos'),
    value: 'AprovadoParcialServicos',
    cor: 'primary',
  },
  {
    text: i18n.t('enums.AcaoOrcamentoEnum.aprovadoParcialPecas'),
    value: 'AprovadoParcialPecas',
    cor: 'primary',
  },
  {
    text: i18n.t('enums.AcaoOrcamentoEnum.aprovadoParcialServicosPecas'),
    value: 'AprovadoParcialServicosPecas',
    cor: 'primary',
  },
  {
    text: i18n.t('enums.AcaoOrcamentoEnum.reprovadoServicosPecas'),
    value: 'ReprovadoServicosPecas',
    cor: 'danger',
  },
  {
    text: i18n.t('enums.AcaoOrcamentoEnum.reprovadoServicos'),
    value: 'ReprovadoServicos',
    cor: 'danger',
  },
  {
    text: i18n.t('enums.AcaoOrcamentoEnum.reprovadoPecas'),
    value: 'ReprovadoPecas',
    cor: 'danger',
  },
  {
    text: i18n.t('enums.AcaoOrcamentoEnum.liberadoAprovacao'),
    value: 'LiberadoAprovacao',
    cor: 'primary',
  },
  {
    text: i18n.t('enums.AcaoOrcamentoEnum.aprovadoOrcamentoConsulta'),
    value: 'AprovadoOrcamentoConsulta',
    cor: 'success',
  },
];
